"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaginationResponseSchema = exports.createErrorResponseSchema = exports.createEmptySuccessResponseSchema = exports.createSuccessResponseSchema = exports.BaseErrorResponseSchema = exports.BaseResponseSchema = void 0;
const zod_1 = require("zod");
exports.BaseResponseSchema = zod_1.z.object({
    status: zod_1.z.literal('success'),
    message: zod_1.z.string().optional().nullable(),
    timestamp: zod_1.z.string(),
    statusCode: zod_1.z.number(),
    metaData: zod_1.z.record(zod_1.z.string(), zod_1.z.unknown()).optional(),
});
exports.BaseErrorResponseSchema = zod_1.z.object({
    status: zod_1.z.literal('error'),
    message: zod_1.z.string().optional().nullable(),
    timestamp: zod_1.z.string(),
    statusCode: zod_1.z.number(),
    error: zod_1.z.object({
        details: zod_1.z.string().nullable(),
        path: zod_1.z.string(),
        errorCode: zod_1.z.union([zod_1.z.number(), zod_1.z.string()]),
    }),
    metaData: zod_1.z.record(zod_1.z.string(), zod_1.z.unknown()).optional(),
});
const createSuccessResponseSchema = (result) => {
    return exports.BaseResponseSchema.extend({ result: result });
};
exports.createSuccessResponseSchema = createSuccessResponseSchema;
const createEmptySuccessResponseSchema = () => {
    return exports.BaseResponseSchema;
};
exports.createEmptySuccessResponseSchema = createEmptySuccessResponseSchema;
// Schema factory function for error response
const createErrorResponseSchema = (errorDetailsSchema) => {
    return zod_1.z.object({
        status: zod_1.z.literal('error'),
        message: zod_1.z.string().optional().nullable(),
        timestamp: zod_1.z.string(),
        statusCode: zod_1.z.number(),
        error: zod_1.z.object({
            path: zod_1.z.string(),
            details: errorDetailsSchema,
            errorCode: zod_1.z.union([zod_1.z.number(), zod_1.z.string()]),
        }),
        metaData: zod_1.z.record(zod_1.z.string(), zod_1.z.unknown()).optional(),
    });
};
exports.createErrorResponseSchema = createErrorResponseSchema;
exports.PaginationResponseSchema = zod_1.z.object({
    pagination: zod_1.z.object({
        page: zod_1.z.number().min(1).default(1),
        pageSize: zod_1.z.number().min(1).max(100).default(20),
        total: zod_1.z.number().min(0).default(0),
        totalPages: zod_1.z.number().min(0).default(0),
    }),
});
